import { render, staticRenderFns } from "./boot_image.vue?vue&type=template&id=bae93c8e&scoped=true"
import script from "./boot_image.vue?vue&type=script&lang=ts"
export * from "./boot_image.vue?vue&type=script&lang=ts"
import style0 from "./boot_image.vue?vue&type=style&index=0&id=bae93c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae93c8e",
  null
  
)

export default component.exports